import { render } from "./OrderConfirm.vue?vue&type=template&id=06b1e7e1&scoped=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"

import "./OrderConfirm.vue?vue&type=style&index=0&id=06b1e7e1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06b1e7e1"

export default script